import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import {useSelector} from "react-redux";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../_metronic/_partials/controls";
import {Form, Formik} from "formik";
import CardContent from "@material-ui/core/CardContent";
import {MyTextInput} from "../FormFields";
import AdminSnackbar from "../AdminSnackbar";
import Grid from "@material-ui/core/Grid";
import EditOrAddPriceList from "./EditOrAddPriceList";
import {fetchPriceList, fetchProduct, fetchSuppliers, fetchUser} from "../AdminPagesCrud";


function PriceListBasic({priceList, setPriceList, setSupplierName, setClients, setProducts, supplier}) {

    const [edit, setEdit] = useState(false)
    const [snackbarPL, setSnackBarPL] = useState(false)

    const {accessToken} = useSelector (
        ({auth}) =>({
            accessToken: auth.authToken,
        })
    )

    useEffect(() => {
     if (edit === false) {
         fetchPriceList(priceList._id, accessToken).then(response => {
             console.log("This is the response", response)
             setPriceList(response.data)

             fetchSuppliers(response.data.supplierId, accessToken).then(response => {
                 setSupplierName(response.data.entityName)
             });

             let productsTemp =[]
             let clientsTemp = []

             response.data.products.forEach(p => {
                 fetchProduct(p.productId, accessToken).then(response => {
                     let product = response.data
                     product.newPrice = p.newPrice
                     productsTemp.push(product)
                 })
             })
             setProducts(productsTemp);

             response.data.clients.forEach(c => {
                 console.log("client id: ", c)
                 fetchUser(c, accessToken).then(response => {
                     clientsTemp.push(response.data)
                 })
             })
             setClients(clientsTemp);
         });
     }
     // eslint-disable-next-line react-hooks/exhaustive-deps
    },[edit])


    return (
        <>
            {edit ? <EditOrAddPriceList priceList={priceList} showSnackbar={snackbarPL} setShowSnackbar={setSnackBarPL}
                                        supplier={supplier} isNew={false} setIsNew={null} edit={edit} setEdit={setEdit}/> :
                <Card>
                    <CardHeader title="Price List Information">
                        <CardHeaderToolbar>
                            <button type="button" className="btn btn-primary" onClick={() => setEdit(true)}>
                                Edit
                            </button>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                        <Formik
                            initialValues={priceList}
                            onSubmit={(values) => {
                                console.log(values)
                            }}
                        >
                            <Form>
                                <div>
                                    <div className="">
                                        <div className="col-12">
                                            <Card>
                                                <CardContent>
                                                    <Grid container>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <MyTextInput
                                                                    label="Name"
                                                                    name="name"
                                                                    type="text"
                                                                    value={priceList.name}
                                                                    placeholder="Name"
                                                                    disabled
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <MyTextInput
                                                                    label="Supplier"
                                                                    name="supplier"
                                                                    type="text"
                                                                    value={supplier}
                                                                    placeholder="Supplier"
                                                                    disabled
                                                                />
                                                            </Grid>
                                                            {/* <Grid item xs={6}>
                                                                <MyTextInput
                                                                    label="Amount of products"
                                                                    name="products"
                                                                    type="number"
                                                                    value={priceList?.products?.length}
                                                                    placeholder="0"
                                                                    disabled
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <MyTextInput
                                                                    label="Amount of clients"
                                                                    name="email"
                                                                    type="number"
                                                                    value={priceList?.clients?.length}
                                                                    placeholder="0"
                                                                    disabled
                                                                />
                                                            </Grid> */}
                                                            <Grid item xs={12}>
                                                                {priceList.active ?
                                                                    <MyTextInput
                                                                        label="Is Active"
                                                                        name="active"
                                                                        type="text"
                                                                        value="Yes"
                                                                        placeholder="Active"
                                                                        disabled
                                                                    /> :
                                                                    <MyTextInput
                                                                        label="Is Active"
                                                                        name="active"
                                                                        type="text"
                                                                        value="No"
                                                                        placeholder="Active"
                                                                        disabled
                                                                    />
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </Formik>
                    </CardBody>
                    <AdminSnackbar
                        message={'Price List  updated successfully'}
                        setShowSnackbar={setSnackBarPL}
                        showSnackbar={snackbarPL}
                        variant={'success'}
                    />
                </Card>
            }
        </>
    );
}

export default injectIntl(PriceListBasic);